export const SOCIAL_LINKS = {
    facebook: "https://www.facebook.com/studioartigrafichegela/",
    instagram: "https://www.instagram.com/studio_arti_grafiche/",
    youtube: "https://www.youtube.com/results?search_query=Studio+Arti+Grafiche+Gela",
};

export const NAV_LINKS = [
    { id: "home", label: "Home", testid: "nav-link-home" },
    { id: "chi-siamo", label: "Chi Siamo", testid: "nav-link-chi-siamo" },
    { id: "servizi", label: "Servizi", testid: "nav-link-servizi" },
    { id: "portfolio", label: "Portfolio", testid: "nav-link-portfolio" },
    { id: "contatti", label: "Contatti", testid: "nav-link-contatti" },
];

export const SERVICES = [
    {
        id: "personalizzazioni",
        title: "Personalizzazioni",
        subtitle: "Plexiglass, legno e materiali speciali",
        description: "Lavorazione e taglio personalizzato su materiali innovativi per insegne, elementi d'arredo, targhe e trofei.",
        tags: ["Taglio laser", "Insegne 3D", "Targhe", "Adesivi"],
    },
    {
        id: "carte-da-parati",
        title: "Carte da Parati",
        subtitle: "Design e stampe sartoriali per interni",
        description: "Decorazioni murali su misura per residenze, uffici e locali commerciali con texture uniche e resistenti.",
        tags: ["Murales", "Texture materiche", "Posa in opera"],
    },
    {
        id: "tipografia",
        title: "Tipografia",
        subtitle: "Dalla partecipazione al coordinato aziendale",
        description: "Biglietti da visita, partecipazioni di nozze, brochure, cataloghi, carta intestata e packaging con carte pregiate.",
        tags: ["Partecipazioni", "Coordinati", "Cataloghi", "Packaging"],
    },
    {
        id: "gadget",
        title: "Gadget & Merchandising",
        subtitle: "Oggetti, abbigliamento e articoli promozionali",
        description: "Personalizzazione di t-shirt, felpe, accessori, cancelleria e merchandising promozionale per brand ed eventi.",
        tags: ["T-shirt", "Felpe", "Oggettistica", "Eventi"],
    },
    {
        id: "allestimenti",
        title: "Allestimenti",
        subtitle: "Spazi commerciali, fiere, mostre ed eventi",
        description: "Progettazione, produzione e montaggio d'interni per vetrine, stand fieristici, mostre d'arte e installazioni.",
        tags: ["Vetrine", "Stand fieristici", "Mostre", "Montaggio"],
    },
];

export const PORTFOLIO_CATEGORIES = [
    { id: "all", label: "Tutti", testid: "portfolio-filter-all" },
    { id: "personalizzazioni", label: "Personalizzazioni", testid: "portfolio-filter-personalizzazioni" },
    { id: "carte-da-parati", label: "Carte da Parati", testid: "portfolio-filter-carte-da-parati" },
    { id: "tipografia", label: "Tipografia", testid: "portfolio-filter-tipografia" },
    { id: "gadget", label: "Gadget & Abbigliamento", testid: "portfolio-filter-gadget" },
    { id: "allestimenti", label: "Allestimenti", testid: "portfolio-filter-allestimenti" },
];

export const CONTACT_INFO = {
    email: "info@studioartigrafiche.it",
    phone: "+39 389 9265782",
    address: "Via Euclide 5, 93012 Gela (CL), Sicilia",
    hours: "Lunedì – Venerdì: 9:00–13:00 / 16:00–19:45",
};

export const ABOUT_TEXT = "Studio Arti Grafiche nasce come laboratorio di progettazione grafica e stampa, un luogo in cui le idee prendono forma e si trasformano in progetti concreti. Da questa radice creativa si è sviluppata una realtà forgiata da anni di esperienza nel mondo dell'allestimento e del montaggio d'interni.";

export const IMAGES = {
    hero: "https://images.unsplash.com/photo-1561070791-2526d30994b5?crop=entropy&cs=srgb&fm=jpg&q=85",
    about: "https://images.unsplash.com/photo-1744686909434-fd158fca1c35?crop=entropy&cs=srgb&fm=jpg&q=85",
    workshop: "https://images.unsplash.com/photo-1744686909434-fd158fca1c35?crop=entropy&cs=srgb&fm=jpg&q=85",
};
